module.exports = __webpack_public_path__ + "img/alicante-plaza.9062817a.png";